module.exports = __webpack_public_path__ + "media/img/advice/icon--kamata-c12fcb91ec8886610aaf088610df4d44.png";